import React from "react";
import { connect } from 'react-redux';

import { OnMap } from "./SubComponentsRightContent";
import OrdersListItem from "./OrdersListItem";
import { addLike, addDislike } from "../../actions/orderActions";

class OrderSwitcher extends React.Component {
    render() {

        const { session, option, params, dispatch, switchMapList, toggleSwitchMapList} = this.props;
        let orders = this.props.orderList;
        
        const { isFetching, isFetchingMore } = orders;
        const moreOrders = orders.data.next || null;

        let emptyText = 'Заказов нет';
        if(params.id === "complaint") emptyText = 'У Вас нет заказов с претензией'
        if(params.option === "customer" && !params.id) emptyText = 'Вы пока не создали ни один заказ'
        if(params.option === "customer" && params.id === "draft") emptyText = 'У Вас нет черновиков'
        if(params.option === "customer" && params.id === "place") emptyText = 'Ваших размещенных активных заказов нет'
        if(params.option === "customer" && params.id === "wait_contractor") emptyText = 'Ваших заказов на исполнении нет'
        if(params.option === "customer" && params.id === "wait_me") emptyText = 'У Вас нет заказов для приемки'
        if(params.option === "customer" && params.id === "finish") emptyText = 'У Вас нет выполненных заказов'

        if(params.option === "contractor" && !params.id) emptyText = 'Вы пока не участвовали как исполнитель ни в одном заказе'
        if(params.option === "contractor" && params.id === "for_me") emptyText = 'Для Вас пока нет подходящих заказов'
        if(params.option === "contractor" && params.id === "place") emptyText = 'Размещенных активных заказов нет'
        if(params.option === "contractor" && params.id === "wait_me") emptyText = 'У Вас нет заказов для исполнения'
        if(params.option === "contractor" && params.id === "wait_customer") emptyText = 'У Вас нет выполненных заказов для приемки заказчиком'
        if(params.option === "contractor" && params.id === "finish") emptyText = 'Вы пока не выполнили ни один заказ'

        return (
            <div>
                <div className="rounded-white-block screen-bottom-block order-list">
                    <div className="white-block-top header-tabs tab-nav">
                        <div className={switchMapList ? "tab-link active" : "tab-link"} data-id="tab-content1" onClick={() => toggleSwitchMapList(true)}>
                            Список заказов
                        </div>
                        <div className={switchMapList ? "tab-link" : "tab-link active"} data-id="tab-content2" onClick={() => toggleSwitchMapList(false)}>
                            На карте
                        </div>
                    </div>
                    {
                        switchMapList
                        ?   <ul className="tab-content unlimited-block tab-content1 items-list orders-list">
                                {
                                    isFetching ?
                                    <li className="list-item">Загружается...</li>
                                    :
                                    orders.data.results.length ? orders.data.results.map((elem, index) =>
                                        <OrdersListItem
                                            key={index}
                                            {...elem}
                                            option={option}
                                            params={this.props.params}
                                            isLoggedIn={session.isLoggedIn}
                                            currentUserId={session.currentUser && session.currentUser.id}
                                            handleLike={() => dispatch(addLike(elem))}
                                            handleDislike={() => dispatch(addDislike(elem))}
                                        />
                                    )
                                    : <li className="list-item">{emptyText}</li>
                                }
                            </ul>
                        : <OnMap orders={orders}/>
                    }
                </div>
                {
                    moreOrders && !isFetching ?
                    <div className="big-button button-action without-shadow" style={{height:"auto", textAlign:"center",marginTop:"30px",marginBottom:"30px"}}>
                        <button
                            className={isFetchingMore ? 'disabled' : ''}
                            onClick={() => this.props.handleMoreOrders(orders.data.results.length)}
                            >{isFetchingMore ? 'Загружается...' : 'Загрузить еще'}</button>
                    </div>
                    : ''
                }
            </div>
        )
    }
}

export default connect(
	state => ({
		...state
	})
)(OrderSwitcher);


// WEBPACK FOOTER //
// ./src/components/Orders/OrderSwitcher.js